<template>
  <div id="eventSlide" v-if="isLoading === false">
    <div
      id="bg"
      :style="{ backgroundImage: `url(${data.backgroundImage} )` }"
    />
    <div
      :id="overlayID"
      :style="{
        backgroundImage: `linear-gradient(to bottom, ${this.getColorz()})`
      }"
    />

<div id="eventPage" v-bind:class="overlayID === 'overlay_half' ? 'half' : 'full'">
    <div id="eventLogo">
      <img :src="`/img/event-slide-icons/logo.png`" /> <span>EVENTS</span>
    </div>
    <div id="eventTitle">{{ data.title }}</div>
    <div id="eventDescription">{{ data.description }}</div>
    <div id="eventFooter">
      <div class="eventFooter_item">
        <img src="../../public/img/event-slide-icons/calendar.png" />
        <span>{{ data.date }}</span>
      </div>
      <div class="eventFooter_item">
        <img src="../../public/img/event-slide-icons/location.png" />
        <span>{{ data.eventLocation }}</span>
      </div>
</div>

    <div
      id="half_2nd"
      v-if="overlayID === 'overlay_half'"
      :style="{
        backgroundImage: `linear-gradient(to bottom, ${this.getColorz()})`
      }"
    />


    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "EventSlide",
  data() {
    return {
      isLoading: true,
      refreshTimer: null,
      data: null
    };
  },
  computed: {
    overlayID() {
      const { mode } = this.data;

      if (mode === "gradient") return "overlay_full";
      else if (mode === "half") return "overlay_half";
      else if (mode === "photo") return "overlay_photo";
      return "overlay_none";
    }
  },
  methods: {
    load() {
      const urlQuery = new URLSearchParams(window.location.search);

      if (!urlQuery.has("spid")) {
        console.log("Missing Sedna Portal ID (spid) param.");
        return;
      }

      // console.log(process.env.NODE_ENV)

      const url =
        process.env.NODE_ENV === "development"
          ? `http://localhost:8000/api/cms/apps/${urlQuery.get("spid")}`
          : `https://sedna-cms.advent.zone/api/cms/apps/${urlQuery.get(
              "spid"
            )}`;

      axios.get(url).then(result => {
        const data = result.data.data;
        this.data = data;
        this.isLoading = false;

        // console.log('app data', data)
      });
    },
    getColorz() {
      let colorTop;
      let colorBottom;

      const { colorScheme } = this.data;

      if (colorScheme === "violet") {
        colorTop = "#4C1891";
        colorBottom = "#2F0E5B";
      } else if (colorScheme === "blue") {
        colorTop = "#002C89";
        colorBottom = "#001B55";
      } else if (colorScheme === "turquoise") {
        colorTop = "#00AFC4";
        colorBottom = "#008698";
      } else {
        colorTop = "#CD3E79";
        colorBottom = "#902B6B";
      }

      return [colorTop, colorBottom];
    }
  },
  created() {
    window.axios = axios;
    this.load();
    this.refreshTimer = setInterval(this.load, 30 * 60 * 1000); // refresh news every 30 mins
  }
};
</script>

<style>
#eventSlide{
  position: relative;
  width: 100%;
}
#bg {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  z-index: -2;
  position: absolute;
  top: 0;
  left: 0;
}
#overlay_full {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: -1;
}
#overlay_half {
  position: absolute;
  left: 0px;
  top: 0px;
  opacity: 0.9;
  z-index: -1;
}
#half_2nd {
  position: absolute;
  right:0px;
  top: 0px;
  opacity: 0.4;
  z-index: -1;
}
#overlay_photo {
  position: absolute;
  top: 0px;
  left: 0px;
  opacity: 0.4;
  z-index: -1;
}
#overlay_none {
  visibility: hidden;
}

@media screen and (max-width: 3839px) {
  #eventSlide {
    color: white;
    width: 1920px;
    height: 1080px;
  }
  #eventPage{
    padding: 43px 0px 0px 80px;
  }
  #overlay_half, #half_2nd {
    width: 960px;
    height: 1080px;
  }
  #overlay_full, #overlay_photo, #bg {
    width: 1920px;
    height:1080px;
    object-fit: cover;
  }
  #eventLogo {
    height: 130px;
    min-width: 400px;
    font-size: 69px;
    margin-bottom: 210px;
    display: flex;
    align-items: center;
  }
  .full #eventLogo {
    position: relative;
    font-size:79px;
    height:154px;
    margin-bottom: 150px;

  }
  #eventTitle {
    height: 164px;
    margin-bottom: 30px;
    margin-left:30px;
    line-height: 80px;
    font-size:84px;
    width:724px;
  }
 .full #eventTitle{
    font-size: 120px;
    width:auto;
    margin-bottom:20px;
    height: 120px;
  }
  #eventDescription {
    font-size: 40px;
    font-weight: 100;
    width: 802px;
    height: 230px;
    margin-bottom: 150px;
    margin-left:30px;
    line-height: 52px;
  }
  .full #eventDescription {
    font-size: 56px;
    width: 1300px;
    line-height: 68px;
    height: auto;
  }
  #eventFooter {
    height: 40px;
    width: 725px;
    display: flex;
    justify-content: space-between;
  }
  .full #eventFooter {
    position: fixed;
    bottom:330px;
    height: 47px;
    left:110px;
  }
  .eventFooter_item {
    height: 100%;
    display: flex;
    font-size: 32px;
  }
  .eventFooter_item span {
    margin-left: 10px;
  }
}

@media screen and (min-width: 3840px) {
  #eventSlide {
    color: white;
    width: 3840px;
    height: 2160px;
  }
  .full{
    padding: 70px 60px 160px 198px;
  }
  .half {
    padding: 80px 0px 0px 190px;
    max-width: 1440px;
  }
  #overlay_half, #half_2nd {
    width: 1920px;
    height: 2160px;
  }
  #overlay_full, #overlay_photo, #bg {
    width: 3840px;
    height:2160px;
    object-fit: cover;
  }
  #eventLogo {
    height: 300px;
    min-width: 928px;
    font-size: 158px;
    margin-bottom: 330px;
    display: flex;
    align-items: center;
  }
  .half #eventLogo {
    margin-bottom: 390px;
  }
  #eventLogo img {
    max-height: 100%;
  }
  #eventTitle {
    font-size: 272px;
    height: 524px;
    margin-bottom: 30px;
    line-height: 252px;
    width:2796px;
  }
  .half #eventTitle{
    font-size:168px;
    margin-bottom: 50px;
    margin-left:50px;
    width:1447px;
    height: 328px;
    line-height: 160px;
  }
  #eventDescription {
    font-size: 84px;
    font-weight: 200;
    max-width: 2800px;
    height: 300px;
    margin-bottom: 340px;
  }
  .half #eventDescription {
    font-size: 80px;
    line-height: 104px;
    margin-left:50px;
    margin-bottom: 420px;
  }
  #eventFooter {
    height: 94px;
    display: flex;
    justify-content: flex-start;

  }
  .eventFooter_item {
    min-width: 600px;
    height: 100%;
    display: flex;
    font-size: 64px;
    padding-right: 180px;
  }
  .eventFooter_item span {
    margin-left: 20px;
  }
}
img {
  max-height: 100%;
}
</style>
